import(/* webpackMode: "eager" */ "/home/runner/work/full-stack-saas-mcp/full-stack-saas-mcp/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/full-stack-saas-mcp/full-stack-saas-mcp/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/full-stack-saas-mcp/full-stack-saas-mcp/src/app/_components/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/full-stack-saas-mcp/full-stack-saas-mcp/src/app/globals.css");
